import { theme } from "@chakra-ui/core";
import { createMuiTheme } from "@material-ui/core/styles";
import {
  getHeaderFontAsString,
  getBodyFontAsString,
} from "services/shared/Typography";

const muiTheme = createMuiTheme();

export const customTheme = {
  ...theme,
  fonts: {
    heading: getHeaderFontAsString(),
    body: getBodyFontAsString(),
    mono: theme.fonts.mono,
  },
  breakpoints: [
    `${muiTheme.breakpoints.values.sm}px`,
    `${muiTheme.breakpoints.values.md}px`,
    `${muiTheme.breakpoints.values.lg}px`,
    `${muiTheme.breakpoints.values.xl}px`,
  ],
  orange: {
    "50": "#FAECEA",
    "100": "#F1CBC5",
    "200": "#E8AAA0",
    "300": "#E0887B",
    "400": "#D76756",
    "500": "#CE4531",
    "600": "#A53727",
    "700": "#7B2A1E",
    "800": "#521C14",
    "900": "#290E0A",
  },
};
